'use client';

import { useQuery } from '@tanstack/react-query';
import useIsMainnet from '../useIsMainnet';
import { getRetryDelayFn } from '../../utils/query/retryDelay';

export type LBTC_API_RESPONSE = {
	lbtc_estimated_apy: number;
};

const DEFAULT_LBTC_API_RESPONSE: LBTC_API_RESPONSE = {
	lbtc_estimated_apy: 0,
};

export const useLbtcFetch = () => {
	const isMainnet = useIsMainnet();

	return useQuery({
		queryKey: ['lbtcApy'],
		queryFn: async (): Promise<LBTC_API_RESPONSE> => {
			try {
				const response = await fetch(
					'https://mainnet.prod.lombard.finance/api/v1/analytics/estimated-apy'
				);
				if (!response.ok) {
					return DEFAULT_LBTC_API_RESPONSE;
				}
				return response.json();
			} catch (error) {
				console.error('Failed to fetch LBTC metrics: ', error);
				return DEFAULT_LBTC_API_RESPONSE;
			}
		},
		enabled: isMainnet,
		staleTime: 10 * 60 * 1000, // 10 minutes
		retryDelay: getRetryDelayFn(2000),
		retry: 3,
	});
};
